import { Tab } from "../../TabHeader";

export type ManualOccurrenceType = "patrimonial" | "vehicular";

export type ManualOccurrenceModalProps = {
  isOpen: boolean;
  setIsOpen: () => void;
  type: ManualOccurrenceType;
};

export type OccurrenceTabs = {
  patrimonial: Tab[];
  vehicular: Tab[];
};

export const occurrenceTabs: OccurrenceTabs = {
  patrimonial: [
    { index: 0, text: "Dados da ocorrencia" },
    { index: 1, text: "Visão geral" },
    { index: 3, text: "Pronta-Resposta" },
    { index: 2, text: "Tempo de chegada/saída" },
    { index: 4, text: "Anexos" },
    { index: 9, text: "Visualizacao de trajeto" },
    { index: 6, text: "Whatsapp" },
    { index: 7, text: "Pagamento" },
    { index: 8, text: "Historico de ações" },
    { index: 10, text: "Comentários" },
    { index: 5, text: "Finalização" },
  ],
  vehicular: [
    { index: 0, text: "Dados da ocorrencia" },
    { index: 1, text: "Dados do veiculo" },
    { index: 2, text: "Visão geral" },
    { index: 3, text: "Pronta-Resposta" },
    { index: 5, text: "Tempo de chegada/saída" },
    { index: 4, text: "Ultimas localizações" },
    { index: 7, text: "Anexos" },
    { index: 6, text: "Visualizacao de trajeto" },
    { index: 9, text: "Whatsapp" },
    { index: 10, text: "Pagamento" },
    { index: 11, text: "Historico de ações" },
    { index: 8, text: "Finalização" },
    { index: 12, text: "Comentários" },
  ],
};
